import React, { useState } from "react";
import { Badge, Box, Stack, Image, Avatar } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { CloseIcon, ChevronDownIcon } from "@chakra-ui/icons";
import styles from "../../styles/components/homePage.module.css";
import UiButton from "../atoms/UiButton";
import BlogCard from "./BlogCard";
import Link from "next/link";

function BlogSection({ blogList }) {
  const router = useRouter();

  return (
    <Box className={styles.BlogContainer}>
      <Box className={styles.articleHeading}>Related Articles</Box>

      <Box className={styles.blogListContainer}>
        {blogList?.map((item) => {
          return <BlogCard blog={item} />;
        })}
      </Box>

      <Box>
        <Box className={styles.BlogbottomLine}></Box>

        {blogList?.map((blog) => {
          return (
            <div className={styles.BlogCardContainerSmallScreen}>
              <Link
                href={
                  blog?.category
                    ? `/blog/${blog?.category}/${blog?.slug}`
                    : `/blog/${blog?.slug}`
                }
              >
                <a>
                  <h2 className={styles.BlogTitleSmallScreen}>{blog?.title}</h2>
                </a>
                
              </Link>
              <p className={styles.BlogDescriptionForSmallScreen}>{blog?.excerpt}</p>
            </div>
          );
        })}
      </Box>
    </Box>
  );
}

export default BlogSection;
